import { render, staticRenderFns } from "./validated-input.vue?vue&type=template&id=906f3970"
import script from "./validated-input.vue?vue&type=script&lang=js"
export * from "./validated-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports